import React from 'react';
import { ArrowLeft } from 'lucide-react';

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-[#0A0E27] text-gray-300">
      <div className="container mx-auto px-4 py-16 max-w-4xl">
        <a href="/" className="inline-flex items-center space-x-2 text-[#00D9FF] hover:text-white transition-colors mb-8">
          <ArrowLeft className="w-4 h-4" />
          <span>Back to Home</span>
        </a>

        <h1 className="text-4xl font-bold text-white mb-2">Terms of Service</h1>
        <p className="text-gray-500 mb-10">Last updated: {new Date().toLocaleDateString('en-ZA', { year: 'numeric', month: 'long', day: 'numeric' })}</p>

        <div className="space-y-8 text-sm leading-relaxed">
          <section>
            <h2 className="text-xl font-bold text-white mb-3">1. Services</h2>
            <p>Chill Point provides air conditioning, heating, and refrigeration services including but not limited to: installation, repair, servicing, maintenance, and consultation. All services are subject to availability and scheduling in the Ballito and North Coast areas of KwaZulu-Natal, South Africa.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">2. Quotes & Pricing</h2>
            <p>All quotes provided through this website or via communication channels are estimates and may be subject to change upon physical inspection of the equipment or premises. Final pricing will be confirmed before any work commences. Promotional offers are subject to terms and conditions as stated and may be withdrawn at any time.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">3. Warranties</h2>
            <p>Warranties on parts and labour are provided as specified at the time of service. Warranty terms vary depending on the type of service or repair performed and will be communicated to you upon completion of work.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">4. Payment</h2>
            <p>Payment is due upon completion of services unless otherwise agreed in writing. We accept cash, EFT, and card payments. For maintenance contracts, payment terms will be outlined in the service agreement.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">5. Limitation of Liability</h2>
            <p>Chill Point shall not be liable for any indirect, incidental, or consequential damages arising from the use of our services or this website. Our total liability shall not exceed the amount paid for the specific service in question.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">6. Website Use</h2>
            <p>This website is provided for informational purposes and to facilitate service enquiries. The content on this website is provided "as is" without warranties of any kind. We reserve the right to modify or discontinue any aspect of the website at any time.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">7. Contact</h2>
            <p className="mb-3">For questions regarding these terms, please contact us:</p>
            <ul className="space-y-1">
              <li><strong className="text-white">Email:</strong> chillpointexec@gmail.com</li>
              <li><strong className="text-white">Phone:</strong> 064 450 5026</li>
              <li><strong className="text-white">Location:</strong> Ballito, KwaZulu-Natal, South Africa</li>
            </ul>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
